/**
 * Live-update invalidation for competition leaderboards (specs/competitions-hub-client Slice 3).
 *
 * The socket handler previously invalidated only the World Cup's global leaderboard key,
 * so a season pool's standings never moved live. Matching by key SHAPE covers every
 * competition — a strict superset of the old behavior.
 *
 * Key shape: worldCupQueryKeys.leaderboard(id, …) → ['worldcup', <competitionId>, 'leaderboard', …]
 */

export function isCompetitionLeaderboardQueryKey(queryKey: readonly unknown[]): boolean {
  return queryKey[0] === 'worldcup' && queryKey[2] === 'leaderboard';
}
